import detailPop from './detailPop.vue';
import popMgr from '../popMgr';

export default {
    open(link, animation) {
        //  Save the current before popping up url( will later be changed to link,  for sharing ,  restore when put away )
        if (this.popIns && !this.popIns._destroyFlag) {
            this.popIns.setAnimation(animation);
            this.popIns.setEnableAnimation(true);
            this.popIns.setLink(link);
            this.popIns.display(true);
        } else {
            this.popIns = popMgr.create(detailPop, { animation });
            this.popIns.setLink(link);
        }
    }
};
